import { MessageCircle } from "lucide-react";
import { api, whatsappLink } from "@/lib/api";

export default function WhatsAppFloat({ course }) {
  const message = course
    ? `Hello XTM TECHNOLOGIES, I am interested in the ${course} program. Please share course details.`
    : "Hello XTM TECHNOLOGIES, I want to know more about your courses. Please share details.";

  const handleClick = () => {
    api.post("/leads/whatsapp-click", { context: "floating-button", course }).catch(() => {});
  };

  return (
    <a
      href={whatsappLink(message)}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb857] text-white font-semibold rounded-full pl-4 pr-5 py-3 shadow-2xl shadow-green-900/40 transition-colors"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">WhatsApp Us</span>
    </a>
  );
}
